import { render, staticRenderFns } from "./capabilities.vue?vue&type=template&id=90a2dae6&scoped=true&"
import script from "./capabilities.vue?vue&type=script&lang=js&"
export * from "./capabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a2dae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90a2dae6')) {
      api.createRecord('90a2dae6', component.options)
    } else {
      api.reload('90a2dae6', component.options)
    }
    module.hot.accept("./capabilities.vue?vue&type=template&id=90a2dae6&scoped=true&", function () {
      api.rerender('90a2dae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers_portal/captains/fields/capabilities.vue"
export default component.exports